var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberSevenFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberSevenFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22ZM15.5543 8.27143C15.6592 8.14009 15.7248 7.98183 15.7438 7.81483C15.7627 7.64783 15.7341 7.47888 15.6613 7.3274C15.5884 7.17593 15.4743 7.04809 15.3321 6.95858C15.1898 6.86907 15.0252 6.82153 14.8571 6.82143H9.14286C8.90606 6.82143 8.67896 6.9155 8.51151 7.08294C8.34407 7.25038 8.25 7.47749 8.25 7.71429V9.14286C8.25 9.37966 8.34407 9.60676 8.51151 9.7742C8.67896 9.94165 8.90606 10.0357 9.14286 10.0357C9.37966 10.0357 9.60676 9.94165 9.7742 9.7742C9.94165 9.60676 10.0357 9.37966 10.0357 9.14286V8.60714H13.0786C11.7914 10.5999 11.1068 12.9219 11.1071 15.2943V16.2857C11.1071 16.5225 11.2012 16.7496 11.3687 16.9171C11.5361 17.0845 11.7632 17.1786 12 17.1786C12.2368 17.1786 12.4639 17.0845 12.6313 16.9171C12.7988 16.7496 12.8929 16.5225 12.8929 16.2857V15.2943C12.8929 12.9029 13.7071 10.58 15.2014 8.71286L15.5543 8.27143Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberSevenFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberSevenFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberSevenFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-seven-filled') === undefined) {
    customElements.define('cat-icon-number-seven-filled', BlocksIconNumberSevenFilled);
}
